import React from 'react';
import { SurveyLayout, SurveyResult } from 'components';

export type NotFoundProps = {
  title: string;
  description?: string;
};

export const NotFound: React.FC<NotFoundProps> = (props: NotFoundProps) => {
  const { title, description } = props;

  return (
    <SurveyLayout.$>
      <SurveyResult.$ title={title} description={description} error />
    </SurveyLayout.$>
  );
};
